import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { alert } from "../utils/comm";

const ProtectedRoute = ({ children }) => {
    // 개발환경에서 stric Mode로 인해 컴포넌트가 2번 렌더링되어 alert가 2번띄워지는것 방지(배포시에는 상관없음)
    const alertedRef = useRef(false);
    const navigate = useNavigate(); // 리액트 라우터 v6 기준
    const isLoggedIn = document.cookie.includes("isLogined=true");
    
    useEffect(() => {
        const runGuard = async () => {
            if (!isLoggedIn && !alertedRef.current) {
                alertedRef.current = true;
                await alert({ body: "로그인 후 이용 가능합니다." });
                navigate("/login", { replace: true });
            }
        };
        runGuard();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn]);
    
    return isLoggedIn ? children : null;
};

export default ProtectedRoute;
